import { isDefined } from "@clipboard-health/util-ts";
import { differenceInHours, parseISO } from "date-fns";

interface IsBonusEligibleShiftProps {
  createdAt?: string;
  minimumPostedHours: number;
}

export function isBonusEligibleShift(props: IsBonusEligibleShiftProps): boolean {
  const { createdAt, minimumPostedHours } = props;

  if (!isDefined(createdAt)) {
    return false;
  }

  return differenceInHours(new Date(), parseISO(createdAt)) >= minimumPostedHours;
}
